const initialState = { projectProfiles: [] };
export const projectProfileReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case "ADD_PROJECT_PROFILE":
      return { ...state, projectProfiles: payload };
    default:
      return state;
  }
};
